import { Plus } from 'lucide-react';
import { Link, useNavigate } from 'react-router';
import { useAppState } from '@/app/useAppState';
import { Avatar } from '@/components/ui/Avatar';
import { ButtonLink } from '@/components/ui/Button';
import { ScreenHeader } from '@/components/ui/ScreenHeader';
import { curriculum } from '@/content/curriculum';
import { useI18n } from '@/i18n/context';
import { LanguagePicker } from './LanguagePicker';

export function ProfilesScreen() {
  const { learners, selectLearner } = useAppState();
  const { t, l } = useI18n();
  const navigate = useNavigate();

  const open = async (id: string) => {
    await selectLearner(id);
    navigate('/learn');
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex justify-end">
        <LanguagePicker />
      </div>
      <ScreenHeader title={t('profiles.title')} />
      <ul className="grid grid-cols-2 gap-4 sm:grid-cols-3">
        {learners.map((learner) => {
          const name = learner.nickname ?? t('profiles.anonymous');
          const level = curriculum.level(learner.levelId);
          return (
            <li key={learner.id}>
              <button
                type="button"
                onClick={() => void open(learner.id)}
                aria-label={t('profiles.play', { name })}
                className="flex w-full flex-col items-center gap-3 rounded-[var(--radius-card)] bg-surface p-5 shadow-[var(--shadow-card)] transition-transform hover:-translate-y-0.5"
              >
                <Avatar avatar={learner.avatar} size="lg" />
                <span className="text-lg font-extrabold">{name}</span>
                {level && <span className="text-sm text-ink-muted">{l(level.name)}</span>}
              </button>
            </li>
          );
        })}
        <li>
          <Link
            to="/profiles/new"
            className="flex h-full min-h-44 w-full flex-col items-center justify-center gap-3 rounded-[var(--radius-card)] border-2 border-dashed border-brand-200 p-5 font-extrabold text-brand-700 hover:bg-brand-50"
          >
            <Plus aria-hidden className="size-10" />
            {t('profiles.add')}
          </Link>
        </li>
      </ul>
      <div className="flex justify-center">
        <ButtonLink to="/parent" variant="ghost">
          {t('welcome.parentArea')}
        </ButtonLink>
      </div>
    </div>
  );
}
